import { Component, OnInit, ViewChild  } from '@angular/core';
import { ManageUsersService } from './manage-users.service';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { MatPaginator, MatTableDataSource, MatSort, MatSnackBar } from '@angular/material';
import * as FileSaver from 'file-saver';
import { UtilsService } from '../shared/utils-service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.css']
})
export class ManageUsersComponent implements OnInit {
private loader: boolean= false;
private users: any = [];
private companyCodes: any = [];
private groupCodes: any = [];
private branchCodes: any = [];
model: any = {};
errorHandler: any = {};
errorHandlerEdit: any = {};
dataJson : any = [];
displayedColumns: any = [];
dataSource: any = [];
private editMember: any = [];
private addData: any = [];
private deleteData: any = [];
private mandFields: any = [];
private mandFieldsEdit: any = [];
private user_id:number;
private exporturl: string = this.utils.url+"/ddmf_backoff/users/exportCSV";
private url: string = this.utils.url+"/ddmf_backoff/users";
private companyurl: string = this.utils.url+"/ddmf_backoff/cpnycode";
private groupurl: string = this.utils.url+"/ddmf_backoff/groupname";
private srchUrl: string = this.utils.url+"/ddmf_backoff/users/search";
private deleteuserUrl: string = this.utils.url+"/ddmf_backoff/removeUser/";
private showtimeslot: boolean
private status: boolean
private statusAdd: boolean
private statusEdit: boolean
private statusPassword: boolean //DDMF-101
private mandStatus: boolean
private mandStatusEdit: boolean
private urlDelete: string;
srchData: any = {};
accessTime: any = {};
loggedInUser: any = {};
access_time: any[] = [0,0,0,0,0,0,0];
userIdAdded : string = '';
weekDays: any = ['Sunday','Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;
	userStatusList: any[]; //DDMF-101
 
  constructor(private manageUsersService: ManageUsersService, private http: Http, private utils: UtilsService, private matSnackBar: MatSnackBar, private router: Router) {
    this.showtimeslot = false;
    this.status = false;
    this.statusAdd = false;
    this.statusPassword = false;//DDMF-101
    this.statusEdit = false;
   this.mandStatus = true;
   this.mandStatusEdit = true;
    this.loggedInUser = this.utils._checkSession({'page': 'manage-users'});
    this.mandFields = ['userId','searchName','password','group_id','expiryDate','emailId'];//DDMF-101 aded 'emailId'
    this.mandFieldsEdit = ['userId','name','groupName','expiryDate','email','userStatus'];//DDMF-101 aded 'email','userStatus'
	this.srchData = {};
	this.userStatusList=[{name:"Active",value:'A'},{name:"Deactivated",value:'I'}];//DDMF-101
  // this.paginator.pageIndex = 0;

this.getCompanyCode().subscribe(data => {
    this.companyCodes = data['_body'];
    this.companyCodes = JSON.parse(this.companyCodes);
    
});

this.getGroupCode().subscribe(data => {
    this.groupCodes = data['_body'];
    this.groupCodes = JSON.parse(this.groupCodes);
    
});
  
   }

  ngOnInit() {
    this.getData().subscribe(data => {
      this.displayedColumns = ['userId', 'companyCode', 'branchCode', 'groupName', 'name', 'expiryDate', 'email', 'action'];
        this.users = data['_body'];
        this.users = JSON.parse(this.users);
        this.dataJson = new MatTableDataSource<Element>(this.users);
      this.dataJson.paginator = this.paginator;
      this.dataJson.sort = this.sort;
        
    });
    for (let j = 0; j < 7; j++) {
      this.accessTimeChange('c', j, 'add');
    }
  }
  
  viewDetails(usr) {
  //console.log('/view-user/'+ usr);
  	this.router.navigateByUrl('/view-user/'+ usr);
  }
  
  getCompanyCode(){
  var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
  	return this.http.get(this.companyurl,{ headers: headers });
  }
  
  getGroupCode(){
  var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
  	return this.http.get(this.groupurl,{ headers: headers });
  }
  
  getData() {
  var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
    return this.http.get(this.url,{ headers: headers });
  } 
  
  buttonClick(){
  this.showtimeslot = true;
  }
  onClick(){
  this.showtimeslot = false;
  }
  
   export(){
//   	this.http.get(this.exporturl).subscribe(data => {
//     var mediaType = 'application/csv';
//                     var blob = new Blob([data['_body']], {type: mediaType});
//                     var filename = 'AdminUsers.csv';
//                     FileSaver.saveAs(blob, filename);
// });
    // console.log(this.users);
      let exportHeads = ['userId', 'companyCode', 'branchCode', 'groupName', 'name', 'expiryDate', 'email'];
    this.utils.exportCSV(this.users, 'AdminUsers.csv', exportHeads);
  }
  
  getBranchCode(code, editMember?){
    // console.log(code, code !== '');
    if (code !== 'null') {
      let branchCodeUrl= this.companyurl+'/'+code;
      var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
      this.http.get(branchCodeUrl,{ headers: headers }).subscribe(data => {
        this.branchCodes = data['_body'];
        this.branchCodes = JSON.parse(this.branchCodes);
      });
      if (editMember) this.editMember.branchCode = '';
    // console.log(this.editMember, 'editMember');
    }
  }
  
  addUser(){ 
   		console.log({
       "userId": this._checkNull(this.model.userId),
        "branchCode": this._checkNull(this.model.branch_code),
        "groupId": this._checkNull(this.model.group_id),
        "passwd": this._checkNull(this.model.password),
        "name": this._checkNull(this.model.searchName),
        "expiryDate": this.utils.dateToDB(this.model.expiryDate),
		"email": this._checkNull(this.model.emailId),
		"userStatus": this._checkNull(this.model.userStatus),//DDMF-101
        "startTime0": this.accessTime['startTime0'],
        "endTime0": this.accessTime['endTime0'],
        "startTime1": this.accessTime['startTime1'],
        "endTime1": this.accessTime['endTime1'],
        "startTime2": this.accessTime['startTime2'],
        "endTime2": this.accessTime['endTime2'],
        "startTime3": this.accessTime['startTime3'],
        "endTime3": this.accessTime['endTime3'],
        "startTime4": this.accessTime['startTime4'],
        "endTime4": this.accessTime['endTime4'],
        "startTime5": this.accessTime['startTime5'],
        "endTime5": this.accessTime['endTime5'],
        "startTime6": this.accessTime['startTime6'],
        "endTime6": this.accessTime['endTime6']
    });
    let errorFlag = false;
    this.mandStatus = false;
   	for(let e in this.errorHandler){
   		console.log(e, this.errorHandler[e], 'eeeeee')
   		if (this.errorHandler[e]) {
   			this.utils.notify('Please enter value for all mandatory fields');
   			errorFlag = true;
   		} 
   	}
    this.userIdAdded = this.model.userId;
   console.log(this.model.userId, this.userIdAdded, 'this.model_up');
  if (!errorFlag){
  var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
      this.timeFormat(this.accessTime);
      this.loader=true;
   this.http.post(this.url,JSON.stringify({
       "userId": this._checkNull(this.model.userId),
        "branchCode": this._checkNull(this.model.branch_code),
        "groupId": this._checkNull(this.model.group_id),
        "passwd": this._checkNull(this.model.password),
        "name": this._checkNull(this.model.searchName),
        "expiryDate": this.utils.dateToDB(this.model.expiryDate),
		"email": this._checkNull(this.model.emailId),
		"userStatus": "A",//DDMF-101
		"firstTimeLoginInd": "Y",//DDMF-101
        "startTime0": this.accessTime['startTime0'],
        "endTime0": this.accessTime['endTime0'],
        "startTime1": this.accessTime['startTime1'],
        "endTime1": this.accessTime['endTime1'],
        "startTime2": this.accessTime['startTime2'],
        "endTime2": this.accessTime['endTime2'],
        "startTime3": this.accessTime['startTime3'],
        "endTime3": this.accessTime['endTime3'],
        "startTime4": this.accessTime['startTime4'],
        "endTime4": this.accessTime['endTime4'],
        "startTime5": this.accessTime['startTime5'],
        "endTime5": this.accessTime['endTime5'],
        "startTime6": this.accessTime['startTime6'],
        "endTime6": this.accessTime['endTime6']
    }), { headers: headers }).subscribe(res => {
	    var message = res['_body'];
	    // this.matSnackBar.open(message, 'Close', {
	    //   duration: 5000,
	    // });
	    
      this.utils.notify(message);
      // console.log(this.model, 'this.model down');
	    /*this.paginator.pageIndex = 0;
	    this.getData().subscribe(data => {
	    this.loader=false;
		  	this.displayedColumns = ['userId', 'companyCode', 'branchCode', 'groupName', 'name', 'expiryDate', 'email', 'action'];
		    this.users = data['_body'];
		    this.users = JSON.parse(this.users);
		    this.dataJson = new MatTableDataSource<Element>(this.users);
			this.dataJson.paginator = this.paginator;
			this.dataJson.sort = this.sort;*/
        this.goToURL('/view-user/'+ this.userIdAdded);
		    
		// });
	}, 
	error => {
	this.loader=false;
		// this.matSnackBar.open(error['_body'], 'Close', {
	 //      duration: 5000,
	 //    });
        this.utils.notify(error['_body']);
	});   
  this.model = {};
  	}
  }
  
  editUser($event, telcoMember){
    this.access_time = ['2', '2', '2', '2', '2', '2', '2'];
    this.editMember = telcoMember;
  	this.accessTime = Object.assign({}, telcoMember);
    this.mandatoryCheckEdit(this.editMember);
    // console.log(telcoMember, 'telcoMember', this.editMember);
  	this.getBranchCode(telcoMember.companyCode);
  }
  
    editMyTelcoCredit(){
  		var editurl= this.url+'/'+this.editMember.userId;
  		let errorFlag = false;
   	for(let e in this.errorHandlerEdit){
   		console.log(e, this.errorHandlerEdit[e], 'eeeeee')
   		if (this.errorHandlerEdit[e]) {
   			errorFlag = true;
   			this.utils.notify('Please enter value for all mandatory fields');
   		}
   	}
   console.log(this.model.userId);
  if (!errorFlag){
  		var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);	
      this.timeFormat(this.accessTime);

      console.log({
            "userId": this._checkNull(this.editMember.userId),
            "branchCode": this._checkNull(this.editMember.branchCode),
            "groupName": this._checkNull(this.editMember.groupName),
            "passwd": this._checkNull(this.editMember.passwd),
            "name": this._checkNull(this.editMember.name),
            "expiryDate": this.utils.dateToDB(this.editMember.expiryDate),
			"email": this._checkNull(this.editMember.email),
			"userStatus": this._checkNull(this.editMember.userStatus),
            "startTime0": this.accessTime['startTime0'],
            "endTime0": this.accessTime['endTime0'],
            "startTime1": this.accessTime['startTime1'],
            "endTime1": this.accessTime['endTime1'],
            "startTime2": this.accessTime['startTime2'],
            "endTime2": this.accessTime['endTime2'],
            "startTime3": this.accessTime['startTime3'],
            "endTime3": this.accessTime['endTime3'],
            "startTime4": this.accessTime['startTime4'],
            "endTime4": this.accessTime['endTime4'],
            "startTime5": this.accessTime['startTime5'],
            "endTime5": this.accessTime['endTime5'],
            "startTime6": this.accessTime['startTime6'],
            "endTime6": this.accessTime['endTime6']
        });
        	this.loader=true;
      	  this.http.post(editurl,JSON.stringify({
            "userId": this._checkNull(this.editMember.userId),
            "branchCode": this._checkNull(this.editMember.branchCode),
            "groupName": this._checkNull(this.editMember.groupName),
            "passwd": this._checkNull(this.editMember.passwd),
            "name": this._checkNull(this.editMember.name),
            "expiryDate": this.utils.dateToDB(this.editMember.expiryDate),
			"email": this._checkNull(this.editMember.email),
			"userStatus": this._checkNull(this.editMember.userStatus),
            "startTime0": this.accessTime['startTime0'],
            "endTime0": this.accessTime['endTime0'],
            "startTime1": this.accessTime['startTime1'],
            "endTime1": this.accessTime['endTime1'],
            "startTime2": this.accessTime['startTime2'],
            "endTime2": this.accessTime['endTime2'],
            "startTime3": this.accessTime['startTime3'],
            "endTime3": this.accessTime['endTime3'],
            "startTime4": this.accessTime['startTime4'],
            "endTime4": this.accessTime['endTime4'],
            "startTime5": this.accessTime['startTime5'],
            "endTime5": this.accessTime['endTime5'],
            "startTime6": this.accessTime['startTime6'],
            "endTime6": this.accessTime['endTime6']
        }), { headers: headers }).subscribe(res => {
                var message = res['_body'];
                // this.matSnackBar.open(message, 'Close', {
                //   duration: 5000,
                // });
            this.utils.notify(message);
                this.paginator.pageIndex = 0;
                this.getData().subscribe(data => {
                this.loader=false;
                this.displayedColumns = ['userId', 'companyCode', 'branchCode', 'groupName', 'name', 'expiryDate', 'email', 'action'];
                this.users = data['_body'];
                this.users = JSON.parse(this.users);
                this.dataJson = new MatTableDataSource<Element>(this.users);
            	this.dataJson.paginator = this.paginator;
            	this.dataJson.sort = this.sort;
                
            });
        }, error => {
        this.loader=false;
          var message = error['_body'];
            // this.matSnackBar.open(message, 'Close', {
            //   duration: 5000,
            // });
            this.utils.notify(message);
        });
        	
	  }
  }
  
  deleteUser($event, user){
  if(confirm("Are you sure you want to deactivate the user?")) { //DDMF-101 Message changed
  		this.urlDelete= this.deleteuserUrl+'/'+user.userId;
  			var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
  		
		
  	this.loader=true;
  	this.http.post(this.urlDelete,JSON.stringify({"userId": this.loggedInUser.userId}),{ headers: headers }).subscribe(res => {
  		this.deleteData = res;
  		var message = res['_body'];
      // this.matSnackBar.open(message, 'Close', {
      //   duration: 5000,
      // });
        this.utils.notify(message);
      this.paginator.pageIndex = 0;
      this.getData().subscribe(data => {
      this.loader=false;
        this.displayedColumns = ['userId', 'companyCode', 'branchCode', 'groupName', 'name', 'expiryDate', 'email', 'action'];
          this.users = data['_body'];
          this.users = JSON.parse(this.users);
          this.dataJson = new MatTableDataSource<Element>(this.users);
      	this.dataJson.paginator = this.paginator;
      	this.dataJson.sort = this.sort;
          
      });
		}, error => {
		this.loader=false;
      // this.matSnackBar.open(error['_body'], 'Close', {
      //   duration: 5000,
      // });
        this.utils.notify(error['_body']);
    });
	}
	}
	reset(){
	this.status = false;
	this.statusAdd= false;
	this.statusPassword = false;//DDMF-101
	this.statusEdit= false;
	this.paginator.pageIndex = 0;
	this.loader=true;
		this.getData().subscribe(data => {
		this.loader=false;
		  	this.displayedColumns = ['userId', 'companyCode', 'branchCode', 'groupName', 'name', 'expiryDate', 'email', 'action'];
		    this.users = data['_body'];
		    this.users = JSON.parse(this.users);
		    this.dataJson = new MatTableDataSource<Element>(this.users);
			this.dataJson.paginator = this.paginator;
			this.dataJson.sort = this.sort;
		});
		this.srchData = {};
		this.model={};
		this.errorHandler ={};
    for (let j = 0; j < 7; j++) {
      this.accessTimeChange('a', j, 'add');
    }
	}

  searchData() {
    let inpData = {
      "userId" : this._checkNull(this.srchData.userId),
      "branchCode" : this._checkNull(this.srchData.branch_code),
      "companyCode" : this._checkNull(this.srchData.company_code),
      "groupId" : this._checkNull(this.srchData.group_id),
      "name" : this._checkNull(this.srchData.name),
      "expiryDateFrom" : this.utils.dateToDB(this.srchData.expiry_date_from),
      "expiryDateTo" : this.utils.dateToDB(this.srchData.expiry_date_to),
      "email" : this._checkNull(this.srchData.email)
    }
    console.log(inpData, 'inpData');
    this.paginator.pageIndex = 0;
    var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
	this.loader=true;
    this.http.post(this.srchUrl,JSON.stringify({"userId" : this._checkNull(this.srchData.userId),
      "branchCode" : this._checkNull(this.srchData.branch_code),
      "companyCode" : this._checkNull(this.srchData.company_code),
      "groupId" : this._checkNull(this.srchData.group_id),
      "name" : this._checkNull(this.srchData.name),
      "expiryDateFrom" : this.utils.dateToDB(this.srchData.expiry_date_from),
      "expiryDateTo" : this.utils.dateToDB(this.srchData.expiry_date_to),
      "email" : this._checkNull(this.srchData.email)}),{ headers: headers }).subscribe(data => {
      this.loader=false;
      console.log(data, 'data');
      let json = JSON.parse(data['_body']);
      this.users = json;
      this.dataJson = new MatTableDataSource<Element>(json);
      this.dataJson.paginator = this.paginator;
      this.dataJson.sort = this.sort;
    }, error => {
    this.loader=false;
      var message = error['_body'];
      // this.matSnackBar.open(message, 'Close', {
      //   duration: 5000,
      // });
        this.utils.notify(message);
      this.paginator.length = 0;
      this.dataJson = [];
      this.users = [];
      this.dataJson.paginator = this.paginator;
      this.dataJson.sort = this.sort;
    })
  }
  goToURL(url){
		this.router.navigateByUrl(url);
		}
		
	_checkNull(v) {
		return (!v || v === null || v === 'undefined') ? '' : v;
	}
	validate(){
		let email = this.srchData.email;
		// console.log(email, this.utils.validateEmail(email));
		if (!this.utils.validateEmail(email) && email !="") {
			//this.matSnackBar.open('Enter a valid email', 'Close', {
	        	//duration: 5000,
	      	//});
	      	this.status = true;
	      	// console.log(status);
	      	
		} else{
		this.status = false;
		}
		
	}
	validateAdd(){
		let email = this.model.emailId;
		// console.log(email, this.utils.validateEmail(email));
		if (!this.utils.validateEmail(email) && this.editMember.emailId !="") {
			//this.matSnackBar.open('Enter a valid email', 'Close', {
	        	//duration: 5000,
	      	//});
	      	this.statusAdd = true;
	      	// console.log(status);
	      	
		} else{
		this.statusAdd = false;
		}
		
	}
	//DDMF-101: Start
	validatePassword(){
		let password = this.model.password;
		if (!this.utils.validatePassword(password)) {			
	      	this.statusPassword = true;
		} else{
		this.statusPassword = false;
		}
	}
	//DDMF-101: End
	validateEdit(){
		let email = this.editMember.email;
		// console.log(email, this.utils.validateEmail(email));
		if (!this.utils.validateEmail(email) && this.editMember.email !="") {
			//this.matSnackBar.open('Enter a valid email', 'Close', {
	        	//duration: 5000,
	      	//});
	      	this.statusEdit = true;      	
		} else{
		this.statusEdit = false;
		}
		
	}
	//DDMF-101: Start
	//Removed autoPopulate
	/*autoPopulate(userId){
	// console.log(userId);
		this.model.password = this.srchData.password = this.model.userId;
	}*/
	//DDMF-101: End

	mandatoryCheck(model) {
		// console.log(model);
		this.mandFields = ['userId','searchName','password','group_id','expiryDate','emailId'];//DDMF-101 added 'emailId'
		 let count = 0;
		for(let i =0; i<this.mandFields.length; i++){
			let item = this.model[this.mandFields[i]];
			if(item ==undefined || item ==""){
				this.errorHandler[this.mandFields[i]] = true;
				count++;
				//this.mandStatus = true;
			} else {
				this.errorHandler[this.mandFields[i]] = false;
				//this.mandStatus = false;
			}
			// console.log(this.errorHandler);
			//this.errorHandler[item] = !this.model[item];
			//console.log(this.errorHandler[item],'result');
		}
		// console.log(this.mandStatus);
		// console.log(count);
		if(count == 0){
		this.mandStatus = false;
		} else {
		this.mandStatus = true;
		}
		// console.log(this.mandStatus);
	}
	mandatoryCheckEdit(editMember) {
	let countEdit = 0;
	// console.log(this.editMember.expiryDate);
		// console.log(editMember);
		this.mandFieldsEdit = ['userId','name','groupName','expiryDate','email','userStatus'];//DDMF-101 added 'email','userStatus'
		 
		for(let i =0; i<this.mandFieldsEdit.length; i++){
			let item = this.editMember[this.mandFieldsEdit[i]];
			if(item =="" || item ==null){
				this.errorHandlerEdit[this.mandFieldsEdit[i]] = true;
				countEdit++;
			} else {
				this.errorHandlerEdit[this.mandFieldsEdit[i]] = false;
			}
			console.log(this.errorHandlerEdit);
			//this.errorHandlerEdit[item] = !this.editMember[item];
			//console.log(this.errorHandlerEdit[item],'result');
		}
		if(countEdit == 0){
		this.mandStatusEdit = false;
		} else {
		this.mandStatusEdit = true;
		}
		//console.log(this.mandFieldsEdit,'mandFieldsEdit');
	}

  accessTimeChange(type: string, i: number, action: string) {
    // console.log(type, i, action, 'iiiiiiiiiiiiiii');
    if (type === 'c') {
        console.log(this.editMember, 'edit edit edit', action, this.accessTime);
      this.access_time[i] = '2';
      if (action === 'edit') {
        this.accessTime['startTime' + i] = this.editMember['startTime' + i];
        this.accessTime['endTime' + i] = this.editMember['endTime' + i];
      } else {
        this.accessTime['startTime' + i] = '08:00:00';
        this.accessTime['endTime' + i] = '23:00:00';
      }
    } else if (type === 'n') {
      this.access_time[i] = '1';
      this.accessTime['startTime' + i] = '00:00:00';
      this.accessTime['endTime' + i] = '00:00:01';
    } else {
      this.access_time[i] = '0';
      this.accessTime['startTime' + i] = '00:00:01';
      this.accessTime['endTime' + i] = '23:59:59';
    }
  }


  timeFormat(aTime: any) {
    // console.log(this.accessTime, 'accessTime');
    for (let i = 0; i < 7; i++) {
      if (this.accessTime['startTime'+ i] != '') {
        let sTime = this.accessTime['startTime'+ i].split(':');
        if (sTime.length < 3) {
          sTime.push(new Array(3 - sTime.length).fill('00').join(':'));
          this.accessTime['startTime'+ i] = sTime.join(':');
        }
      } else {
        this.accessTime['startTime'+ i] = '00:00:00';
      }

      if (this.accessTime['endTime'+ i] != '') {
        let eTime = this.accessTime['endTime'+ i].split(':');
        if (eTime.length < 3) {
          eTime.push(new Array(3 - eTime.length).fill('00').join(':'));
          console.log(eTime, eTime.length, 3 - eTime.length);
          this.accessTime['endTime'+ i] = eTime.join(':');
        }
      } else {
        this.accessTime['startTime'+ i] = '00:00:00';
        this.accessTime['endTime'+ i] = '00:00:00';
      }
    }
    // console.log(this.accessTime);
  }
  dateValidate(e, val, field){
		if(e.charCode >= 48 && e.charCode <= 57){
		console.log(val.length);
			if(val.length == 4){
				val= val+'-';
				console.log(val);
				this.srchData[field] = val;
			} else if(val.length == 7){
				val= val+'-';
				console.log(val);
				this.srchData[field] = val;
			}
			console.log(val, 'value', this.srchData[field], field);
		} else {
			e.preventDefault();
		}
	}
	
	dateValidateLeapYear(e, val, field){
		var res = val.split("-");
		if(val.length>'0'&&val.length<'10'){
			this.utils.notify('Invalid Date Format');
			this.srchData[field] = "";
		}
		else if(res[0]=='0000'){
			this.utils.notify('Year is Invalid');
			this.srchData[field] = "";
		}
		else if(res[1]>'12'||res[1]=='00'){
			this.utils.notify('Month is Invalid');
			this.srchData[field] = "";
		}
		else if(res[2]>'31'||res[2]=='00'){
			this.utils.notify('Date is Invalid');
			this.srchData[field] = "";
		}
		else if(res[2]<'32'&&res[2]!='00'){
			if(res[1]=='01' || res[1]=='03'|| res[1]=='05' || res[1]=='07' || res[1]=='08' || res[1]=='10' || res[1]=='12'){			
			}
			else{
				if(res[2]=='31'){
					this.utils.notify('Date is Invalid');
					this.srchData[field] = "";
				}
				else if(res[1]=='02'){
					if(((res[0] % 4 == 0) && (res[0] % 100 != 0)) || (res[0] % 400 == 0))
					{
						if(res[2]>'29'){
							this.utils.notify('Date is Invalid');
							this.srchData[field] = "";
						}						
					}
					else{
						if(res[2]>'28'){
							this.utils.notify('Date is Invalid');
							this.srchData[field] = "";
						}
					}
				}
			}
		}
	}
	
	dateValidateLeapYearAdd(e, val, field){
		var res = val.split("-");
		if(val.length>'0'&&val.length<'10'){
			this.utils.notify('Invalid Date Format');
			this.model[field] = "";
		}
		else if(res[0]=='0000'){
			this.utils.notify('Year is Invalid');
			this.model[field] = "";
		}
		else if(res[1]>'12'||res[1]=='00'){
			this.utils.notify('Month is Invalid');
			this.model[field] = "";
		}
		else if(res[2]>'31'||res[2]=='00'){
			this.utils.notify('Date is Invalid');
			this.model[field] = "";
		}
		else if(res[2]<'32'&&res[2]!='00'){
			if(res[1]=='01' || res[1]=='03'|| res[1]=='05' || res[1]=='07' || res[1]=='08' || res[1]=='10' || res[1]=='12'){			
			}
			else{
				if(res[2]=='31'){
					this.utils.notify('Date is Invalid');
					this.model[field] = "";
				}
				else if(res[1]=='02'){
					if(((res[0] % 4 == 0) && (res[0] % 100 != 0)) || (res[0] % 400 == 0))
					{
						if(res[2]>'29'){
							this.utils.notify('Date is Invalid');
							this.model[field] = "";
						}						
					}
					else{
						if(res[2]>'28'){
							this.utils.notify('Date is Invalid');
							this.model[field] = "";
						}
					}
				}
			}
		}
	}
	
	dateValidateLeapYearEdit(e, val, field){
		var res = val.split("-");
		if(val.length>'0'&&val.length<'10'){
			this.utils.notify('Invalid Date Format');
			this.editMember[field] = "";
		}
		else if(res[0]=='0000'){
			this.utils.notify('Year is Invalid');
			this.editMember[field] = "";
		}
		else if(res[1]>'12'||res[1]=='00'){
			this.utils.notify('Month is Invalid');
			this.editMember[field] = "";
		}
		else if(res[2]>'31'||res[2]=='00'){
			this.utils.notify('Date is Invalid');
			this.editMember[field] = "";
		}
		else if(res[2]<'32'&&res[2]!='00'){
			if(res[1]=='01' || res[1]=='03'|| res[1]=='05' || res[1]=='07' || res[1]=='08' || res[1]=='10' || res[1]=='12'){			
			}
			else{
				if(res[2]=='31'){
					this.utils.notify('Date is Invalid');
					this.editMember[field] = "";
				}
				else if(res[1]=='02'){
					if(((res[0] % 4 == 0) && (res[0] % 100 != 0)) || (res[0] % 400 == 0))
					{
						if(res[2]>'29'){
							this.utils.notify('Date is Invalid');
							this.editMember[field] = "";
						}						
					}
					else{
						if(res[2]>'28'){
							this.utils.notify('Date is Invalid');
							this.editMember[field] = "";
						}
					}
				}
			}
		}
	}
	
	dateValidateAdd(e, val, field){
		if(e.charCode >= 48 && e.charCode <= 57){
		console.log(val.length);
			if(val.length == 4){
				val= val+'-';
				console.log(val);
				this.model[field] = val;
			} else if(val.length == 7){
				val= val+'-';
				console.log(val);
				this.model[field] = val;
			}
			console.log(val, 'value', this.model[field], field);
		} else {
			e.preventDefault();
		}
	}
	
	dateValidateEdit(e, val, field){
		if(e.charCode >= 48 && e.charCode <= 57){
		console.log(val.length);
			if(val.length == 4){
				val= val+'-';
				console.log(val);
				this.editMember[field] = val;
			} else if(val.length == 7){
				val= val+'-';
				console.log(val);
				this.editMember[field] = val;
			}
			console.log(val, 'value', this.editMember[field], field);
		} else {
			e.preventDefault();
		}
	}
	timeValidateAdd(e, val,field){
	console.log('works');
		if(e.charCode >= 48 && e.charCode <= 57){
		console.log(val.length);
			if(val.length == 2){
				val= val+':';
				console.log(val);
				this.accessTime[field] = val;
			} else if(val.length == 5){
				val= val+':';
				console.log(val);
				this.accessTime[field] = val;
			}
			console.log(val, 'value', this.accessTime[field]);
		} else {
			e.preventDefault();
		}
	}
	timeValidateEdit(e, val,field){
	console.log('works', e.charCode, e.which);
		if(e.charCode >= 48 && e.charCode <= 57){
		console.log(val.length);
			if(val.length == 2){
				val= val+':';
				console.log(val);
				this.accessTime[field] = val;
			} else if(val.length == 5){
				val= val+':';
				console.log(val);
				this.accessTime[field] = val;
			}
			console.log(val, 'value', this.accessTime[field]);
		} else {
			e.preventDefault();
		}
	}


}




// WEBPACK FOOTER //
// ./src/app/manage-users/manage-users.component.ts